const DAM_LIBRARY_PATH = '/products/assets';

const damAssetPath = (assetId: string) => `${DAM_LIBRARY_PATH}/${encodeURIComponent(assetId)}`;

/** Asset id from a `/products/assets/:assetId` pathname, or `undefined` for any other path. */
const parseDamAssetId = (pathname: string): string | undefined => {
    const prefix = `${DAM_LIBRARY_PATH}/`;
    if (!pathname.startsWith(prefix)) {
        return undefined;
    }
    const segment = pathname.slice(prefix.length).split('/')[0];
    return segment ? decodeURIComponent(segment) : undefined;
};

/** Whether `pathname` is the library or an asset detail page. */
const isDamLibraryOrAssetPath = (pathname: string) => pathname === DAM_LIBRARY_PATH || parseDamAssetId(pathname) !== undefined;

export { DAM_LIBRARY_PATH, damAssetPath, isDamLibraryOrAssetPath, parseDamAssetId };
